<template>
  <div>
    <div
      v-for="tag in value"
      :key="tag.id"
      v-b-tooltip.hover
      :title="tag.descricao"
      :style="`background-color:${tag.cor}`"
      class="lista-cartao-tag tag-label"
    >
      <span>{{ tag.descricao }}</span>
    </div>
  </div>
</template>

<style lang="scss">
.lista-cartao-tag {
  border-radius: 4px;
  display: inline-block;
  margin-right: 0.2rem;
  margin-bottom: 0.2rem;
  overflow: auto;
  position: relative;
  font-size: 10.5px;

  &.tag-label {
    width: auto;
    min-width: 40px;
    color: white;
    font-weight: 500;
    max-width: 198px;
    padding: 0 2px;
  }
}
</style>

<script>
export default {
  name: 'TagsCartaoProposta',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
